import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Bookmark, ExternalLink, Zap } from "lucide-react";

/**
 * Bloc promo "Installer le Curateur Express" pour les dashboards
 * contributeur / admin / page Plus / onboarding.
 *
 * Pédagogique : explique en 7 étapes le workflow.
 */
export function BookmarkletPromoCard({ compact = false }) {
  return (
    <Card className="p-5 border-2 border-[hsl(var(--aito-lagoon))]/30 bg-gradient-to-br from-[hsl(var(--aito-lagoon))]/5 to-[hsl(var(--aito-gold))]/5" data-testid="bookmarklet-promo-card">
      <div className="flex items-start gap-3 mb-3">
        <div className="rounded-full p-2 bg-[hsl(var(--aito-lagoon))]/10">
          <Zap className="h-5 w-5 text-[hsl(var(--aito-lagoon))]" />
        </div>
        <div className="flex-1">
          <h3 className="font-display font-bold text-base flex items-center gap-2">
            Curateur Express
            <Badge variant="secondary" className="text-[10px]">1 clic</Badge>
          </h3>
          <p className="text-xs text-muted-foreground">
            Soumets un article en cours de lecture, n'importe où sur le web, sans quitter ta page.
          </p>
        </div>
      </div>

      {!compact && (
        <ol className="text-xs space-y-1.5 mb-4 list-decimal list-inside text-muted-foreground">
          <li>Ouvre la page <Link to="/bookmarklet" className="text-[hsl(var(--aito-lagoon))] hover:underline font-medium">/bookmarklet</Link></li>
          <li>Glisse le bouton <strong>« + AITO.PF »</strong> dans ta barre de favoris</li>
          <li>Lis n'importe quel article sportif</li>
          <li>Clique sur le favori pour ouvrir le formulaire prérempli</li>
          <li>Vérifie le titre, la source et l'image</li>
          <li>Coche la déclaration de droits</li>
          <li>Envoie en validation admin (jamais publié automatiquement)</li>
        </ol>
      )}

      <div className="flex flex-wrap items-center gap-2">
        <Button asChild data-testid="bookmarklet-install-btn" size="sm">
          <Link to="/bookmarklet">
            <Bookmark className="h-3.5 w-3.5 mr-1.5" />
            Installer le bouton
          </Link>
        </Button>
        <Button asChild variant="outline" size="sm" data-testid="bookmarklet-quickcurate-btn">
          <Link to="/quick-curate">
            <ExternalLink className="h-3.5 w-3.5 mr-1.5" />
            Soumettre manuellement
          </Link>
        </Button>
      </div>
    </Card>
  );
}
